<template>
  <a :href="url" class="navigation-banner" :class="classes">
    <Media class="media" :images="images" />
    <div class="content">
      <div v-if="meta" class="meta">
        <div v-if="meta.left" class="meta__left">{{ meta.left }}</div>
        <div v-if="meta.right" class="meta__right">{{ meta.right }}</div>
      </div>
      <Button tag="a" :href="url" form="underline-invert" class="title">
        {{ text }}
      </Button>
    </div>
  </a>
</template>

<script>
import Button from "@/components/ButtonV2.vue";
import Media from "@/components/Media.vue";

export default {
  name: "NavigationBanner",
  components: {
    Media,
    Button,
  },
  props: {
    images: {
      type: Object,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    meta: {
      type: Object,
      default: null,
    },
    stretch: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: "primary",
      validator: (value) => {
        return ["primary", "highlight"].includes(value);
      },
    },
  },
  computed: {
    classes() {
      return {
        "navigation-banner--highlight": this.theme === "highlight",
        "navigation-banner--stretch": this.stretch,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation-banner {
  text-decoration: none;

  &--stretch {
    .media {
      aspect-ratio: 3/2;
    }
  }

  &--highlight .title {
    color: $color-red;
  }
}

.media {
  aspect-ratio: 3/2;
  margin-bottom: 12px;
  overflow: hidden;
  object-position: top;

  @include respond-above(md) {
    aspect-ratio: 4/5;
  }
}

.content {
  padding: 0 24px 20px;

  @include respond-above(md) {
    padding: 0;
  }
}

.meta {
  @include utility-label(12px);
  color: $color-grey-dark;
  margin-bottom: 2px;
  display: flex;
  justify-content: space-between;
}

.title :deep(.text) {
  display: block;
  text-align: center;
  @include editorial-headline(18px);
  text-transform: none;
}
</style>
